import { isFeatureEnabled } from 'owa-feature-flags';
import { isProactiveDraftEnabled } from 'owa-capabilities-definitions/lib/isProactiveDraftEnabled';
import { HEURISTIC_SCORE_1, HEURISTIC_SCORE_2, HEURISTIC_SCORE_3 } from './constants';

export default function shouldFetchProactiveDraftsForHeuristicScore(
    proactiveDraftsHeuristicsScore: number | null | undefined
): boolean {
    return (
        isFeatureEnabled('mon-copilot-proactive-drafts-enableForAllEmails') ||
        (isProactiveDraftEnabled() &&
            !!proactiveDraftsHeuristicsScore &&
            (proactiveDraftsHeuristicsScore == HEURISTIC_SCORE_1 ||
                proactiveDraftsHeuristicsScore == HEURISTIC_SCORE_2 ||
                (isFeatureEnabled('mon-copilot-proactive-draft-heuristic-score-3') &&
                    proactiveDraftsHeuristicsScore == HEURISTIC_SCORE_3)))
    );
}
